import rootReducer from 'src/store/rootReducer';
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
  reducer: rootReducer,
});

export const { dispatch } = store;

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export interface IApiPendingState {
  [key: string]: boolean;
}

export interface IApiRejectedState {
  [key: string]: boolean;
}
